export default function getJWTHeaders(jwtToken) {
  if (!jwtToken) return {};

  return { Authorization: `Bearer ${jwtToken}` };
}
